<ifc-base-dialog
  title="Offer accepted!"
  [actions]="actions"
  (actionClicked)="onActionClicked()"
>
  <ng-template #content>
    <p class="dialog-description">
      A confirmation email is on its way and the finance team has been notified. Your updated schedule takes effect next billing cycle.
    </p>
  </ng-template>
</ifc-base-dialog>
